export default __webpack_public_path__ + "static/media/yarden_website_screenshot.99110d68.png";